// Este pequeño script maneja la selección visual de layouts
document.addEventListener('turbo:load', () => {
  document.querySelectorAll('.layout-preview-option').forEach(option => {
    option.addEventListener('click', function() {
      // Remover selected de todos
      document.querySelectorAll('.layout-preview-option').forEach(opt => {
        opt.classList.remove('selected')
      })
      
      // Agregar selected al clickeado
      this.classList.add('selected')
      
      // Marcar el radio button
      const radio = this.querySelector('input[type="radio"]')
      if (radio) {
        radio.checked = true
        // Disparar evento change para que Stimulus lo capture
        radio.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  })
})
